import { Component, Input } from '@angular/core';

import { BibliographicResourceType } from '®shared/bibliographic-resource';

import { ResourceMetadata } from './item-metadata.utils';

@Component({
  selector: 'rl-resource-metadata',
  templateUrl: './resource-metadata.component.html',
})
export class ResourceMetadataComponent {
  @Input() metadata: ResourceMetadata[];
  @Input() resourceType?: BibliographicResourceType;
}
